/**
 * Shared style constants for consistent component sizing across the application.
 * These can be spread together to compose styles as needed.
 * 
 * Usage examples:
 *   // Simple height
 *   <MGrid wrapperStyle={defaultHeightStyle} />
 *   
 *   // Composed on the fly
 *   <MCard sx={{ ...defaultHeightStyle, ...overflowAutoStyle }} />
 *   
 *   // Pre-composed convenience
 *   <MGrid wrapperStyle={defaultMaxHeightWithOverflow} />
 *   
 *   // Mix with custom styles
 *   <MCard sx={{ ...defaultHeightStyle, backgroundColor: "red" }} />
 */

// Base constant - change this to update the default height across all usages
export const DEFAULT_CARD_HEIGHT = 400;

// Composable style primitives - spread these together as needed
export const defaultHeightStyle = { height: DEFAULT_CARD_HEIGHT };
export const defaultMaxHeightStyle = { maxHeight: DEFAULT_CARD_HEIGHT };
export const overflowAutoStyle = { overflow: "auto" };

// Pre-composed common combinations for convenience
export const defaultHeightWithOverflow = { ...defaultHeightStyle, ...overflowAutoStyle };
export const defaultMaxHeightWithOverflow = { ...defaultMaxHeightStyle, ...overflowAutoStyle };
